document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.media__custom-controls').forEach(function (btn) {
    if (btn.dataset.bound) return;
    btn.dataset.bound = '1';

    var container = btn.closest('.video-background');
    if (!container) return;

    function getVisibleVideo() {
      var candidates = container.querySelectorAll('video');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        var wrapper = el.closest('.video-background__player') || el;
        if (wrapper.offsetParent !== null) return el;
      }
      return container.querySelector('video');
    }

    function syncState() {
      var video = getVisibleVideo();
      if (video) btn.classList.toggle('is-paused', video.paused);
    }

    function bindVideo() {
      var video = getVisibleVideo();
      if (!video || video.dataset.controlsBound) return;
      video.dataset.controlsBound = '1';
      video.addEventListener('play', syncState);
      video.addEventListener('pause', syncState);
      syncState();
    }

    btn.addEventListener('click', function () {
      var video = getVisibleVideo();
      if (!video) return;
      video.paused ? video.play() : video.pause();
    });

    var observer = new MutationObserver(bindVideo);
    observer.observe(container, { childList: true, subtree: true });
    window.addEventListener('resize', bindVideo);
    bindVideo();
  });
});